var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewer-container",class:{ hide: !_vm.isShow }},[_c('div',{staticClass:"close-btn"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.close}},[_c('i',{staticClass:"fas fa-times"})])]),_c('div',{staticClass:"current-image"},[_c('img',{attrs:{"src":_vm.currentImage,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }